import { render, staticRenderFns } from "./CartaoInformacoesPrestador.vue?vue&type=template&id=3286c875&scoped=true"
import script from "./CartaoInformacoesPrestador.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesPrestador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286c875",
  null
  
)

export default component.exports